import { InMemoryCache } from '@apollo/client'
import { apolloCacheConfig } from './apollo-cache-config'

export const createApolloCache = () => {
  return new InMemoryCache(apolloCacheConfig)
}

export const apolloCache = createApolloCache()
